$mol_view_tree2_to_js_test_ex_bidi_in_dictionary_foo $mol_object
	event *
		click? <=> run? null
